module.exports = __webpack_public_path__ + "img/Logo-mob2.0602674b.svg";